import { z } from "zod";
import { baseSearchSchema, deviceSearchSchema, navigationSearchSchema } from "../-search-params";

const deviceNavigationSearchSchema = navigationSearchSchema.pick({ returnTo: true });

export const deviceSearchParamsSchema = z.object({
	...baseSearchSchema.shape,
	...deviceSearchSchema.shape,
	...deviceNavigationSearchSchema.shape,
});

export type DeviceSearchParams = z.infer<typeof deviceSearchParamsSchema>;

export const validateDeviceSearch = (search: Record<string, unknown>): DeviceSearchParams => {
	return deviceSearchParamsSchema.parse(search);
};
